
var dicomParser = require("dicom-parser");
var filecount = 0;
var dicomTag = Uint8Array.from([68, 73, 67, 77]);
const tagBeginOffsetBig = 12;
const tagBeginOffsetSmall = 8;
const smallOffsetVr = [
    "AE", "AS", "AT", "CS", "DA", "DS", "DT", "FL", "FD", "IS", "LO", "LT", "PN", "SH", "SL", "SS", "ST", "TM", "UI",
    "UL", "US"
];
var lookUpDictionaryForUid = {};
var lookUpDictionaryForFileGroupId = {};
var clinicalTrialsProfile = {
    "x00200010":
        { "group": "0020", "element": "0010", "tag": "Study ID", "vr": "SH", "type": "String", "vm": 1, "action": "Z" },
    "x00080050":
    {
        "group": "0008",
        "element": "0050",
        "tag": "Accession Number",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00080054":
    {
        "group": "0008",
        "element": "0054",
        "tag": "Retrieve AE Title",
        "vr": "AE",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00080081":
    {
        "group": "0008",
        "element": "0081",
        "tag": "Institution Address",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00080082":
    {
        "group": "0008",
        "element": "0082",
        "tag": "Institution Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00080090":
    {
        "group": "0008",
        "element": "0090",
        "tag": "Referring Physician's Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00080092":
    {
        "group": "0008",
        "element": "0092",
        "tag": "Referring Physician's Address",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00080094":
    {
        "group": "0008",
        "element": "0094",
        "tag": "Referring Physician's Telephone Numbers",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00080096":
    {
        "group": "0008",
        "element": "0096",
        "tag": "Referring Physician Identification Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00080201":
    {
        "group": "0008",
        "element": "0201",
        "tag": "Timezone Offset From UTC",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081010":
    {
        "group": "0008",
        "element": "1010",
        "tag": "Station Name",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081040":
    {
        "group": "0008",
        "element": "1040",
        "tag": "Institutional Department Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081048":
    {
        "group": "0008",
        "element": "1048",
        "tag": "Physician(s) of Record",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081049":
    {
        "group": "0008",
        "element": "1049",
        "tag": "Physician(s) of Record Identification Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00081050":
    {
        "group": "0008",
        "element": "1050",
        "tag": "Performing Physician's Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081052":
    {
        "group": "0008",
        "element": "1052",
        "tag": "Performing Physician Identification Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00081060":
    {
        "group": "0008",
        "element": "1060",
        "tag": "Name of Physician(s) Reading Study",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081062":
    {
        "group": "0008",
        "element": "1062",
        "tag": "Physician(s) Reading Study Identification Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00081070":
    {
        "group": "0008",
        "element": "1070",
        "tag": "Operators' Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081072":
    {
        "group": "0008",
        "element": "1072",
        "tag": "Operator Identification Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00081080":
    {
        "group": "0008",
        "element": "1080",
        "tag": "Admitting Diagnoses Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00081084":
    {
        "group": "0008",
        "element": "1084",
        "tag": "Admitting Diagnoses Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00081120":
    {
        "group": "0008",
        "element": "1120",
        "tag": "Referenced Patient Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00082111":
    {
        "group": "0008",
        "element": "2111",
        "tag": "Derivation Description",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00082120":
    {
        "group": "0008",
        "element": "2120",
        "tag": "Stage Name",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00082127":
    {
        "group": "0008",
        "element": "2127",
        "tag": "View Name",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00084000":
    {
        "group": "0008",
        "element": "4000",
        "tag": "Identifying Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00100010":
    {
        "group": "0010",
        "element": "0010",
        "tag": "Patient's Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00100020":
    {
        "group": "0010",
        "element": "0020",
        "tag": "Patient ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00100021":
    {
        "group": "0010",
        "element": "0021",
        "tag": "Issuer of Patient ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00100030":
    {
        "group": "0010",
        "element": "0030",
        "tag": "Patient's Birth Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00100032":
    {
        "group": "0010",
        "element": "0032",
        "tag": "Patient's Birth Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00100050":
    {
        "group": "0010",
        "element": "0050",
        "tag": "Patient's Insurance Plan Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00100101":
    {
        "group": "0010",
        "element": "0101",
        "tag": "Patient's Primary Language Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00100102":
    {
        "group": "0010",
        "element": "0102",
        "tag": "Patient's Primary Language Modifier Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "Z"
    },
    "x00101000":
    {
        "group": "0010",
        "element": "1000",
        "tag": "Other Patient IDs",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101001":
    {
        "group": "0010",
        "element": "1001",
        "tag": "Other Patient Names",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101002":
    {
        "group": "0010",
        "element": "1002",
        "tag": "Other Patient IDs Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00101005":
    {
        "group": "0010",
        "element": "1005",
        "tag": "Patient's Birth Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101020":
    {
        "group": "0010",
        "element": "1020",
        "tag": "Patient's Size",
        "vr": "DS",
        "type": "Decimal",
        "vm": 1,
        "action": "Z"
    },
    "x00101030":
    {
        "group": "0010",
        "element": "1030",
        "tag": "Patient's Weight",
        "vr": "DS",
        "type": "Decimal",
        "vm": 1,
        "action": "Z"
    },
    "x00101040":
    {
        "group": "0010",
        "element": "1040",
        "tag": "Patient's Address",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101050":
    {
        "group": "0010",
        "element": "1050",
        "tag": "Insurance Plan Identification",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101060":
    {
        "group": "0010",
        "element": "1060",
        "tag": "Patient's Mother's Birth Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101080":
    {
        "group": "0010",
        "element": "1080",
        "tag": "Military Rank",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101081":
    {
        "group": "0010",
        "element": "1081",
        "tag": "Branch of Service",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101090":
    {
        "group": "0010",
        "element": "1090",
        "tag": "Medical Record Locator",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00101100":
    {
        "group": "0010",
        "element": "1100",
        "tag": "Referenced Patient Photo Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00102000":
    {
        "group": "0010",
        "element": "2000",
        "tag": "Medical Alerts",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102110":
    {
        "group": "0010",
        "element": "2110",
        "tag": "Allergies",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102150":
    {
        "group": "0010",
        "element": "2150",
        "tag": "Country of Residence",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102152":
    {
        "group": "0010",
        "element": "2152",
        "tag": "Region of Residence",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102154":
    {
        "group": "0010",
        "element": "2154",
        "tag": "Patient's Telephone Numbers",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102160":
    {
        "group": "0010",
        "element": "2160",
        "tag": "Ethnic Group",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102180":
    {
        "group": "0010",
        "element": "2180",
        "tag": "Occupation",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x001021a0":
    {
        "group": "0010",
        "element": "21a0",
        "tag": "Smoking Status",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x001021b0":
    {
        "group": "0010",
        "element": "21b0",
        "tag": "Additional Patient History",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x001021c0":
    {
        "group": "0010",
        "element": "21c0",
        "tag": "Pregnancy Status",
        "vr": "US",
        "type": "UInt16",
        "vm": 1,
        "action": "X"
    },
    "x001021d0":
    {
        "group": "0010",
        "element": "21d0",
        "tag": "Last Menstrual Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x001021f0":
    {
        "group": "0010",
        "element": "21f0",
        "tag": "Patient's Religious Preference",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102203":
    {
        "group": "0010",
        "element": "2203",
        "tag": "Patient's Sex Neutered",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102297":
    {
        "group": "0010",
        "element": "2297",
        "tag": "Responsible Person",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00102299":
    {
        "group": "0010",
        "element": "2299",
        "tag": "Responsible Organization",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00104000":
    {
        "group": "0010",
        "element": "4000",
        "tag": "Patient Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120010":
    {
        "group": "0012",
        "element": "0010",
        "tag": "Clinical Trial Sponsor Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120020":
    {
        "group": "0012",
        "element": "0020",
        "tag": "Clinical Trial Protocol ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120021":
    {
        "group": "0012",
        "element": "0021",
        "tag": "Clinical Trial Protocol Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120030":
    {
        "group": "0012",
        "element": "0030",
        "tag": "Clinical Trial Site ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120031":
    {
        "group": "0012",
        "element": "0031",
        "tag": "Clinical Trial Site Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120040":
    {
        "group": "0012",
        "element": "0040",
        "tag": "Clinical Trial Subject ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120042":
    {
        "group": "0012",
        "element": "0042",
        "tag": "Clinical Trial Subject Reading ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120050":
    {
        "group": "0012",
        "element": "0050",
        "tag": "Clinical Trial Time Point ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120051":
    {
        "group": "0012",
        "element": "0051",
        "tag": "Clinical Trial Time Point Description",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00120060":
    {
        "group": "0012",
        "element": "0060",
        "tag": "Clinical Trial Coordinating Center Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00180034":
    {
        "group": "0018",
        "element": "0034",
        "tag": "Intervention Drug Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00180035":
    {
        "group": "0018",
        "element": "0035",
        "tag": "Intervention Drug Start Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00180036":
    {
        "group": "0018",
        "element": "0036",
        "tag": "Intervention Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00180037":
    {
        "group": "0018",
        "element": "0037",
        "tag": "Therapy Type",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00180038":
    {
        "group": "0018",
        "element": "0038",
        "tag": "Intervention Status",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00180039":
    {
        "group": "0018",
        "element": "0039",
        "tag": "Therapy Description",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0018003a":
    {
        "group": "0018",
        "element": "003a",
        "tag": "Intervention Description",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00181030":
    {
        "group": "0018",
        "element": "1030",
        "tag": "Protocol Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00181400":
    {
        "group": "0018",
        "element": "1400",
        "tag": "Acquisition Device Processing Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00184000":
    {
        "group": "0018",
        "element": "4000",
        "tag": "Acquisition Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00189424":
    {
        "group": "0018",
        "element": "9424",
        "tag": "Acquisition Protocol Description",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0018a003":
    {
        "group": "0018",
        "element": "a003",
        "tag": "Contribution Description",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00203401":
    {
        "group": "0020",
        "element": "3401",
        "tag": "Modifying Device ID",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00203404":
    {
        "group": "0020",
        "element": "3404",
        "tag": "Modifying Device Manufacturer",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00203406":
    {
        "group": "0020",
        "element": "3406",
        "tag": "Modified Image Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00204000":
    {
        "group": "0020",
        "element": "4000",
        "tag": "Image Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00209158":
    {
        "group": "0020",
        "element": "9158",
        "tag": "Frame Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00280301":
    {
        "group": "0028",
        "element": "0301",
        "tag": "Burned In Annotation",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00284000":
    {
        "group": "0028",
        "element": "4000",
        "tag": "Image Presentation Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00320012":
    {
        "group": "0032",
        "element": "0012",
        "tag": "Study ID Issuer",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00321030":
    {
        "group": "0032",
        "element": "1030",
        "tag": "Reason for Study",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00321032":
    {
        "group": "0032",
        "element": "1032",
        "tag": "Requesting Physician",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00321033":
    {
        "group": "0032",
        "element": "1033",
        "tag": "Requesting Service",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00321060":
    {
        "group": "0032",
        "element": "1060",
        "tag": "Requested Procedure Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00321064":
    {
        "group": "0032",
        "element": "1064",
        "tag": "Requested Procedure Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00324000":
    {
        "group": "0032",
        "element": "4000",
        "tag": "Study Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380004":
    {
        "group": "0038",
        "element": "0004",
        "tag": "Referenced Patient Alias Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00380008":
    {
        "group": "0038",
        "element": "0008",
        "tag": "Visit Status ID",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380010":
    {
        "group": "0038",
        "element": "0010",
        "tag": "Admission ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380011":
    {
        "group": "0038",
        "element": "0011",
        "tag": "Issuer of Admission ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380016":
    {
        "group": "0038",
        "element": "0016",
        "tag": "Route of Admissions",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0038001a":
    {
        "group": "0038",
        "element": "001a",
        "tag": "Scheduled Admission Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x0038001b":
    {
        "group": "0038",
        "element": "001b",
        "tag": "Scheduled Admission Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x0038001c":
    {
        "group": "0038",
        "element": "001c",
        "tag": "Scheduled Discharge Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x0038001d":
    {
        "group": "0038",
        "element": "001d",
        "tag": "Scheduled Discharge Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x0038001e":
    {
        "group": "0038",
        "element": "001e",
        "tag": "Scheduled Patient Institution Residence",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380020":
    {
        "group": "0038",
        "element": "0020",
        "tag": "Admitting Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00380021":
    {
        "group": "0038",
        "element": "0021",
        "tag": "Admitting Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00380030":
    {
        "group": "0038",
        "element": "0030",
        "tag": "Discharge Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00380032":
    {
        "group": "0038",
        "element": "0032",
        "tag": "Discharge Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00380040":
    {
        "group": "0038",
        "element": "0040",
        "tag": "Discharge Diagnosis Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380044":
    {
        "group": "0038",
        "element": "0044",
        "tag": "Discharge Diagnosis Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00380050":
    {
        "group": "0038",
        "element": "0050",
        "tag": "Special Needs",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380060":
    {
        "group": "0038",
        "element": "0060",
        "tag": "Service Episode ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380061":
    {
        "group": "0038",
        "element": "0061",
        "tag": "Issuer of Service Episode ID",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380062":
    {
        "group": "0038",
        "element": "0062",
        "tag": "Service Episode Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380100":
    {
        "group": "0038",
        "element": "0100",
        "tag": "Pertinent Documents Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00380300":
    {
        "group": "0038",
        "element": "0300",
        "tag": "Current Patient Location",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380400":
    {
        "group": "0038",
        "element": "0400",
        "tag": "Patient's Institution Residence",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380500":
    {
        "group": "0038",
        "element": "0500",
        "tag": "Patient State",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00380502":
    {
        "group": "0038",
        "element": "0502",
        "tag": "Patient Clinical Trial Participation Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00384000":
    {
        "group": "0038",
        "element": "4000",
        "tag": "Visit Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400006":
    {
        "group": "0040",
        "element": "0006",
        "tag": "Scheduled Performing Physician's Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400007":
    {
        "group": "0040",
        "element": "0007",
        "tag": "Scheduled Procedure Step Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040000b":
    {
        "group": "0040",
        "element": "000b",
        "tag": "Scheduled Performing Physician Identification Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00400012":
    {
        "group": "0040",
        "element": "0012",
        "tag": "Pre-Medication",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400241":
    {
        "group": "0040",
        "element": "0241",
        "tag": "Performed Station AE Title",
        "vr": "AE",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400242":
    {
        "group": "0040",
        "element": "0242",
        "tag": "Performed Station Name",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400243":
    {
        "group": "0040",
        "element": "0243",
        "tag": "Performed Location",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400244":
    {
        "group": "0040",
        "element": "0244",
        "tag": "Performed Procedure Step Start Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00400245":
    {
        "group": "0040",
        "element": "0245",
        "tag": "Performed Procedure Step Start Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00400250":
    {
        "group": "0040",
        "element": "0250",
        "tag": "Performed Procedure Step End Date",
        "vr": "DA",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00400251":
    {
        "group": "0040",
        "element": "0251",
        "tag": "Performed Procedure Step End Time",
        "vr": "TM",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x00400252":
    {
        "group": "0040",
        "element": "0252",
        "tag": "Performed Procedure Step Status",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400253":
    {
        "group": "0040",
        "element": "0253",
        "tag": "Performed Procedure Step ID",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400254":
    {
        "group": "0040",
        "element": "0254",
        "tag": "Performed Procedure Step Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400255":
    {
        "group": "0040",
        "element": "0255",
        "tag": "Performed Procedure Type Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400260":
    {
        "group": "0040",
        "element": "0260",
        "tag": "Performed Protocol Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00400275":
    {
        "group": "0040",
        "element": "0275",
        "tag": "Request Attributes Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00400280":
    {
        "group": "0040",
        "element": "0280",
        "tag": "Comments on the Performed Procedure Step",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400320":
    {
        "group": "0040",
        "element": "0320",
        "tag": "Billing Procedure Step Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00400400":
    {
        "group": "0040",
        "element": "0400",
        "tag": "Comments on the Scheduled Procedure Step",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040050a":
    {
        "group": "0040",
        "element": "050a",
        "tag": "Specimen Accession Number",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400550":
    {
        "group": "0040",
        "element": "0550",
        "tag": "Specimen Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00400551":
    {
        "group": "0040",
        "element": "0551",
        "tag": "Specimen Identifier",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00400555":
    {
        "group": "0040",
        "element": "0555",
        "tag": "Acquisition Context Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "Z"
    },
    "x00400556":
    {
        "group": "0040",
        "element": "0556",
        "tag": "Acquisition Context Description",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040059a":
    {
        "group": "0040",
        "element": "059a",
        "tag": "Specimen Type Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00401001":
    {
        "group": "0040",
        "element": "1001",
        "tag": "Requested Procedure ID",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00401002":
    {
        "group": "0040",
        "element": "1002",
        "tag": "Reason for the Requested Procedure",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00401003":
    {
        "group": "0040",
        "element": "1003",
        "tag": "Requested Procedure Priority",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00401004":
    {
        "group": "0040",
        "element": "1004",
        "tag": "Patient Transport Arrangements",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00401005":
    {
        "group": "0040",
        "element": "1005",
        "tag": "Requested Procedure Location",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040100a":
    {
        "group": "0040",
        "element": "100a",
        "tag": "Reason for Requested Procedure Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00401010":
    {
        "group": "0040",
        "element": "1010",
        "tag": "Names of Intended Recipients of Results",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00401011":
    {
        "group": "0040",
        "element": "1011",
        "tag": "Intended Recipients of Results Identification Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "Z"
    },
    "x00401101":
    {
        "group": "0040",
        "element": "1101",
        "tag": "Person Identification Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00401102":
    {
        "group": "0040",
        "element": "1102",
        "tag": "Person's Address",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00401103":
    {
        "group": "0040",
        "element": "1103",
        "tag": "Person's Telephone Numbers",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00401400":
    {
        "group": "0040",
        "element": "1400",
        "tag": "Requested Procedure Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00402001":
    {
        "group": "0040",
        "element": "2001",
        "tag": "Reason for the Imaging Service Request",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00402008":
    {
        "group": "0040",
        "element": "2008",
        "tag": "Order Entered By",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00402009":
    {
        "group": "0040",
        "element": "2009",
        "tag": "Order Enterer's Location",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00402010":
    {
        "group": "0040",
        "element": "2010",
        "tag": "Order Callback Phone Number",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00402016":
    {
        "group": "0040",
        "element": "2016",
        "tag": "Placer Order Number / Imaging Service Request",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00402017":
    {
        "group": "0040",
        "element": "2017",
        "tag": "Filler Order Number / Imaging Service Request",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00402400":
    {
        "group": "0040",
        "element": "2400",
        "tag": "Imaging Service Request Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00403001":
    {
        "group": "0040",
        "element": "3001",
        "tag": "Confidentiality Constraint on Patient Data Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00404026":
    {
        "group": "0040",
        "element": "4026",
        "tag": "Scheduled Station Class Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00404034":
    {
        "group": "0040",
        "element": "4034",
        "tag": "Scheduled Human Performers Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00404035":
    {
        "group": "0040",
        "element": "4035",
        "tag": "Actual Human Performers Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "Z"
    },
    "x00404036":
    {
        "group": "0040",
        "element": "4036",
        "tag": "Human Performer's Organization",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00404037":
    {
        "group": "0040",
        "element": "4037",
        "tag": "Human Performer's Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a027":
    {
        "group": "0040",
        "element": "a027",
        "tag": "Verifying Organization",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a073":
    {
        "group": "0040",
        "element": "a073",
        "tag": "Verifying Observer Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "Z"
    },
    "x0040a075":
    {
        "group": "0040",
        "element": "a075",
        "tag": "Verifying Observer Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a078":
    {
        "group": "0040",
        "element": "a078",
        "tag": "Author Observer Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "Z"
    },
    "x0040a07a":
    {
        "group": "0040",
        "element": "a07a",
        "tag": "Participant Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x0040a07c":
    {
        "group": "0040",
        "element": "a07c",
        "tag": "Custodial Organization Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x0040a123":
    {
        "group": "0040",
        "element": "a123",
        "tag": "Person Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a124":
        { "group": "0040", "element": "a124", "tag": "UID", "vr": "UI", "type": "String", "vm": 1, "action": "U" },
    "x0040a307":
    {
        "group": "0040",
        "element": "a307",
        "tag": "Current Observer (Trial)",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a352":
    {
        "group": "0040",
        "element": "a352",
        "tag": "Verbal Source (Trial)",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a353":
    {
        "group": "0040",
        "element": "a353",
        "tag": "Address (Trial)",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a354":
    {
        "group": "0040",
        "element": "a354",
        "tag": "Telephone Number (Trial)",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040a358":
    {
        "group": "0040",
        "element": "a358",
        "tag": "Verbal Source Identifier Code Sequence (Trial)",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x0040a390":
    {
        "group": "0040",
        "element": "a390",
        "tag": "HL7 Structured Document Reference Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x0040a730":
    {
        "group": "0040",
        "element": "a730",
        "tag": "Content Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "Z"
    },
    "x0040e001":
    {
        "group": "0040",
        "element": "e001",
        "tag": "HL7 Instance Identifier",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0040e004":
    {
        "group": "0040",
        "element": "e004",
        "tag": "HL7 Document Effective Time",
        "vr": "DT",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x0040e006":
    {
        "group": "0040",
        "element": "e006",
        "tag": "HL7 Document Type Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00420010":
    {
        "group": "0042",
        "element": "0010",
        "tag": "Document Title",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00420011":
    {
        "group": "0042",
        "element": "0011",
        "tag": "Encapsulated Document",
        "vr": "OB",
        "type": "Byte[]",
        "vm": 1,
        "action": "Z"
    },
    "x00700001":
    {
        "group": "0070",
        "element": "0001",
        "tag": "Graphic Annotation Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00700006":
    {
        "group": "0070",
        "element": "0006",
        "tag": "Unformatted Text Value",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00700084":
    {
        "group": "0070",
        "element": "0084",
        "tag": "Content Creator's Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00700086":
    {
        "group": "0070",
        "element": "0086",
        "tag": "Content Creator's Identification Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00720002":
    {
        "group": "0072",
        "element": "0002",
        "tag": "Hanging Protocol Name",
        "vr": "SH",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00720004":
    {
        "group": "0072",
        "element": "0004",
        "tag": "Hanging Protocol Description",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00720006":
    {
        "group": "0072",
        "element": "0006",
        "tag": "Hanging Protocol Level",
        "vr": "CS",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00720008":
    {
        "group": "0072",
        "element": "0008",
        "tag": "Hanging Protocol Creator",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x0072000a":
    {
        "group": "0072",
        "element": "000a",
        "tag": "Hanging Protocol Creation DateTime",
        "vr": "DT",
        "type": "DateTime",
        "vm": 1,
        "action": "Z"
    },
    "x0072000c":
    {
        "group": "0072",
        "element": "000c",
        "tag": "Hanging Protocol Definition Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x0072000e":
    {
        "group": "0072",
        "element": "000e",
        "tag": "Hanging Protocol User Identification Code Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00720010":
    {
        "group": "0072",
        "element": "0010",
        "tag": "Hanging Protocol User Group Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00720012":
    {
        "group": "0072",
        "element": "0012",
        "tag": "Source Hanging Protocol Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00880200":
    {
        "group": "0088",
        "element": "0200",
        "tag": "Icon Image Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x00880904":
    {
        "group": "0088",
        "element": "0904",
        "tag": "Topic Title",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00880906":
    {
        "group": "0088",
        "element": "0906",
        "tag": "Topic Subject",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00880910":
    {
        "group": "0088",
        "element": "0910",
        "tag": "Topic Author",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x00880912":
    {
        "group": "0088",
        "element": "0912",
        "tag": "Topic Keywords",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x04000100":
    {
        "group": "0400",
        "element": "0100",
        "tag": "Digital Signature UID",
        "vr": "UI",
        "type": "String",
        "vm": 1,
        "action": "U"
    },
    "x04000402":
    {
        "group": "0400",
        "element": "0402",
        "tag": "Referenced Digital Signature Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x04000403":
    {
        "group": "0400",
        "element": "0403",
        "tag": "Referenced SOP Instance MAC Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x04000404":
        { "group": "0400", "element": "0404", "tag": "MAC", "vr": "OB", "type": "Byte[]", "vm": 1, "action": "Z" },
    "x04000550":
    {
        "group": "0400",
        "element": "0550",
        "tag": "Modified Attributes Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x04000561":
    {
        "group": "0400",
        "element": "0561",
        "tag": "Original Attributes Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x20300020":
    {
        "group": "2030",
        "element": "0020",
        "tag": "Text String",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x21000140":
    {
        "group": "2100",
        "element": "0140",
        "tag": "Destination AE",
        "vr": "AE",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x21100030":
    {
        "group": "2110",
        "element": "0030",
        "tag": "Printer Name",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x30060026":
        { "group": "3006", "element": "0026", "tag": "ROI Name", "vr": "LO", "type": "String", "vm": 1, "action": "Z" },
    "x30060028":
    {
        "group": "3006",
        "element": "0028",
        "tag": "ROI Description",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x30060088":
    {
        "group": "3006",
        "element": "0088",
        "tag": "ROI Observation Description",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x300600a6":
    {
        "group": "3006",
        "element": "00a6",
        "tag": "ROI Interpreter",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x300e0008":
    {
        "group": "300e",
        "element": "0008",
        "tag": "Reviewer Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40000010":
    {
        "group": "4000",
        "element": "0010",
        "tag": "Arbitrary",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40004000":
    {
        "group": "4000",
        "element": "4000",
        "tag": "Text Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40080042":
    {
        "group": "4008",
        "element": "0042",
        "tag": "Results ID Issuer",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40080102":
    {
        "group": "4008",
        "element": "0102",
        "tag": "Interpretation Recorder",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x4008010a":
    {
        "group": "4008",
        "element": "010a",
        "tag": "Interpretation Transcriber",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x4008010b":
    {
        "group": "4008",
        "element": "010b",
        "tag": "Interpretation Text",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x4008010c":
    {
        "group": "4008",
        "element": "010c",
        "tag": "Interpretation Author",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40080111":
    {
        "group": "4008",
        "element": "0111",
        "tag": "Interpretation Approver Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x40080114":
    {
        "group": "4008",
        "element": "0114",
        "tag": "Physician Approving Interpretation",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40080115":
    {
        "group": "4008",
        "element": "0115",
        "tag": "Interpretation Diagnosis Description",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40080118":
    {
        "group": "4008",
        "element": "0118",
        "tag": "Results Distribution List Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "x40080119":
    {
        "group": "4008",
        "element": "0119",
        "tag": "Distribution Name",
        "vr": "PN",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x4008011a":
    {
        "group": "4008",
        "element": "011a",
        "tag": "Distribution Address",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40080202":
    {
        "group": "4008",
        "element": "0202",
        "tag": "Interpretation ID Issuer",
        "vr": "LO",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40080300":
    {
        "group": "4008",
        "element": "0300",
        "tag": "Impressions",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x40084000":
    {
        "group": "4008",
        "element": "4000",
        "tag": "Results Comments",
        "vr": "ST",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "x50003000":
    {
        "group": "5000",
        "element": "3000",
        "tag": "Curve Data",
        "vr": "OB",
        "type": "Byte[]",
        "vm": 1,
        "action": "Z"
    },
    "x60003000":
    {
        "group": "6000",
        "element": "3000",
        "tag": "Overlay Data",
        "vr": "OB",
        "type": "Byte[]",
        "vm": 1,
        "action": "Z"
    },
    "x60004000":
    {
        "group": "6000",
        "element": "4000",
        "tag": "Overlay Comments",
        "vr": "LT",
        "type": "String",
        "vm": 1,
        "action": "Z"
    },
    "xfffafffa":
    {
        "group": "fffa",
        "element": "fffa",
        "tag": "Digital Signatures Sequence",
        "vr": "SQ",
        "type": null,
        "vm": 1,
        "action": "X"
    },
    "xfffcfffc": {
        "group": "fffc",
        "element": "fffc",
        "tag": "Data Set Trailing Padding",
        "vr": "OB",
        "type": "Byte[]",
        "vm": 1,
        "action": "Z"
    },
    "x00181088": { "group": "0018", "element": "1088", "tag": "Heart Rate", "action": "U" }
};

async function makeAnonymizedValue(tag, originalText, securityProfileAction) {
    //patient name & patient ID
    if (securityProfileAction === "Z") {
        return "";
    } else if (securityProfileAction === "U") {
        
        if (lookUpDictionaryForUid.hasOwnProperty(originalText))
            return lookUpDictionaryForUid[originalText];

        const anonymisedUid = await hashUidGenerator(originalText);
        lookUpDictionaryForUid[originalText] = anonymisedUid;
        // series UId
        if (tag === "x0020000e") {
            if (!lookUpDictionaryForFileGroupId.hasOwnProperty(anonymisedUid)) {
                lookUpDictionaryForFileGroupId[anonymisedUid] = anonymisedUid;
            }

        }
        return anonymisedUid;
    } else {
        return originalText;
    }
}

async function hashUidGenerator(text) {
    const msgUint8 = new TextEncoder().encode(text);
    const hashBuffer = await crypto.subtle.digest("SHA-1", msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    let hashComponent = hashArray.map(b => b.toString(10)).join("");
    if (hashComponent[0] === "0") {
        hashComponent = hashComponent.replaceAt(0, "1");
    }
    const hashString = `2.25.${hashComponent}`;
    return hashString;
}

String.prototype.replaceAt = function(index, replacement) {
    return this.substr(0, index) + replacement + this.substr(index + replacement.length);
}

/*
 *checkTaglessData(dataSet:<dicomParser.dataSet>, byteArrayNew:Uint8Array, field:Object<dicomParser.dataSet.elements.Object>, nextTag:<dicomParser.dataSet.elements.Object>,
 *                  lastByte: int, fileTypeImplicit:boolean)
 *
 * This function checks for any data between tags. In DICOM files, thre is sometimes random data between tags which is not
 * pointed at by any tags but is still NECCESSARY to create a valid file. 
 *
 * All function arguments are required and the function is capable of handling both explicit VR transfer syntax & implicit
 * VR transfer syntax.
 */
function checkTaglessData(dataSet, byteArrayNew, field, nextTag, lastByte, fileTypeImplicit) {
    if (fileTypeImplicit || smallOffsetVr.find((e) => e.includes(nextTag.vr))) {
        const nextByte = nextTag.dataOffset - tagBeginOffsetSmall;
        if (nextByte !== lastByte) {
            byteArrayNew.set(dataSet.byteArray.subarray(field.dataOffset + field.length, nextByte),
                lastByte);
            lastByte += nextByte - (field.dataOffset + field.length);
        }
    } else {
        const nextByte = nextTag.dataOffset - tagBeginOffsetBig;
        if (nextByte !== lastByte) {
            byteArrayNew.set(dataSet.byteArray.subarray(field.dataOffset + field.length, nextByte),
                lastByte);
            lastByte += nextByte - (field.dataOffset + field.length);
        }
    }
    return lastByte;
}

/*
 * CopyRelevantData(field:Object<dicomParser.dataSet.elements.Object>, dataSet:<dicomParser.dataSet>, lastByte: int, fieldTag:String,
 *                      byteArrayNew:Uint8Array, keys:Array<String>, fileTypeImplicit:boolean)
 *
 * This function copies the data from relevant tags to the byteArrayNew buffer. Essentially the function recreates the dataSet.byteArray with only tags
 * that are needed.
 *
 */
function copyRelevantData(field, dataSet, lastByte, fieldTag, byteArrayNew, keys, fileTypeImplicit) {
    // Copy tag sub-array to new byte stream.
    if (fileTypeImplicit || smallOffsetVr.find((e) => e.includes(field.vr))) {
        byteArrayNew.set(dataSet.byteArray.subarray(field.dataOffset - tagBeginOffsetSmall,
                field.dataOffset + field.length),
            lastByte);
        lastByte += (tagBeginOffsetSmall + field.length);

        // Check if there is tag-less data between two tags.
        const nextTag = dataSet.elements[keys[keys.indexOf(fieldTag) + 1]];
        if (typeof nextTag !== "undefined")
            lastByte = checkTaglessData(dataSet, byteArrayNew, field, nextTag, lastByte, fileTypeImplicit);

    } else {
        byteArrayNew.set(dataSet.byteArray.subarray(field.dataOffset - tagBeginOffsetBig,
                field.dataOffset + field.length),
            lastByte);
        lastByte += tagBeginOffsetBig + field.length;

        // Check if there is tag-less data between two tags.
        const nextTag = dataSet.elements[keys[keys.indexOf(fieldTag) + 1]];
        if (typeof nextTag !== "undefined")
            lastByte = checkTaglessData(dataSet, byteArrayNew, field, nextTag, lastByte, fileTypeImplicit);

    }
    return lastByte;
}

export async function anonymize(byteArray, anonymousPid="") {
    var dataSet = dicomParser.parseDicom(byteArray);
    filecount += 1;
    var byteArrayNew = new Uint8Array(dataSet.byteArray.length);
    byteArrayNew.set(dicomTag, 128);
    var lastByte = 132;
    let keys = Object.keys(dataSet.elements);
    let fileTypeImplicit = false;

    // Writes the data related to groupId : 0002 at the beginning of the file. The dicomParser.parseDicom()
    // parses the groupId : 0002 at the end of elements list. Here we write the data at the beginning and then
    // delete the reference to the element to avoid rewriting the data at a later stage. 
    for (let tag in dataSet.elements) {
        if (dataSet.elements.hasOwnProperty(tag)) {
            let groupId = parseInt(tag.slice(1, 5), 10);

            if (groupId === 2) {
                let field = dataSet.elements[tag];
                if (field.tag === "x00020010") {
                    if (dataSet.byteArray[field.dataOffset + field.length - 2] === 50)
                        fileTypeImplicit = true;
                }
                if (fileTypeImplicit || smallOffsetVr.find((e) => e.includes(field.vr))) {

                    byteArrayNew.set(dataSet.byteArray.subarray(field.dataOffset - tagBeginOffsetSmall,
                            field.dataOffset + field.length),
                        lastByte);
                    lastByte += tagBeginOffsetSmall + field.length;
                } else {

                    byteArrayNew.set(dataSet.byteArray.subarray(field.dataOffset - tagBeginOffsetBig,
                            field.dataOffset + field.length),
                        lastByte);
                    lastByte += tagBeginOffsetBig + field.length;
                }
                delete dataSet.elements[tag];

            }

        }

    }

    /* Checks if a tag exists in our Profile dictionary. If yes, takes relevant action as defined by
        ClinicalTrialsProfile[key].action.
        
        If tag is not in ClinicalTrialsProfile we write it to buffer if and only if tag groupId is even or 
        it is pixel data.
     */
    for (let fieldTag in dataSet.elements) {

        if (dataSet.elements.hasOwnProperty(fieldTag)) {
            var field = dataSet.elements[fieldTag];

            if (field.length > 0) {
                if (fieldTag in clinicalTrialsProfile) {
                    var originalText = dataSet.string(fieldTag);

                    if (clinicalTrialsProfile[fieldTag].action !== "X") {
                        // anonymize 
                        var _char='';
                        if (fieldTag === "x00100010" || fieldTag === "x00100020") {

                            for (var i = 0; i < field.length; i++) {
                                _char = anonymousPid.length > i ? anonymousPid.charCodeAt(i) : 32;
                                dataSet.byteArray[field.dataOffset + i] = _char;

                            }
                        } else {
                            var deIdentifiedText = await makeAnonymizedValue(fieldTag,
                                originalText,
                                clinicalTrialsProfile[fieldTag].action);
                            for (var iter = 0; iter < field.length; iter++) {
                                _char = deIdentifiedText.length > iter ? deIdentifiedText.charCodeAt(iter) : 32;
                                //dataSet.byteArray[field.dataOffset + iter] = _char; commenting this due to upload issue inspected on blip and dti-selected case.
                            }
                        }

                        // Copy the data to new byte stream.
                        lastByte = copyRelevantData(field,
                            dataSet,
                            lastByte,
                            fieldTag,
                            byteArrayNew,
                            keys,
                            fileTypeImplicit);

                    }

                } else {
                    // copy the data to new byte stream.
                    lastByte = copyRelevantData(field,
                        dataSet,
                        lastByte,
                        fieldTag,
                        byteArrayNew,
                        keys,
                        fileTypeImplicit);

                    /*
                    // check if groupId is even. If yes then write to new array else skip to remove private tags
                    let groupId = parseInt(fieldTag.slice(1, 5), 10);
                    if (groupId % 2 === 0 || fieldTag === "x7fe00010") {

                        // copy the data to new byte stream.
                        lastByte = copyRelevantData(field,
                            dataSet,
                            lastByte,
                            fieldTag,
                            byteArrayNew,
                            keys,
                            fileTypeImplicit);
                    }
                    */
                }

            }
        }

    }

    var anonymisedSeriesInstanceUid = dataSet.string("x0020000e");
    var filename = `Series${filecount}`;
    // Specific clients might require a different implementation. 
    // TODO : Talk to Andy for details.
    var fileGroupId = lookUpDictionaryForFileGroupId[anonymisedSeriesInstanceUid];
    var blob = new Blob([byteArrayNew], { type: "application/dicom" });
    var fd = new FormData();
    fd.append("dcmfile", blob);
    fd.append("filename", filename);
    fd.append("filegroupId", fileGroupId);

    // For development testing. Remove/comment when in production. 
    //var blobUrl = URL.createObjectURL(blob);
    //const anchor = document.createElement('a');
    //anchor.href = blobUrl;
    //anchor.download = "anonymized.dcm";
    //document.body.appendChild(anchor);
    //anchor.click();
    //document.body.removeChild(anchor);

    return fd;
}

